import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialMark } from './commercialThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'commercialMark';

export const markSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialMark(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({
            builder,
            request: getCommercialMark,
        }).addCase(clearCommercialKey, () => commonInitialState);
    },
});

export const { clearCommercialMark } = markSlice.actions;

export const mark = markSlice.reducer;
